import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Overview_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Nexoid Overview</h2>
              <p>
                Nexoid is a complete data management and workflow solution,
                designed for extreme scaling and performance. This website is
                here to help you understand and take advantage of everything the
                Nexoid platform has to offer.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Overview_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/overview/Overview_overview.js